import MultiplySafetyAnchorPointRequestModelBase from '../_generated/modelBases/multiply-safety-anchor-point-request-model-base';

export default class MultiplySafetyAnchorPointRequestModel extends MultiplySafetyAnchorPointRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
